import { useAuthStore } from '../../auth/store/useAuthStore';
import { getRequiresOwnerOnboardingForUser } from './accountSetupCache';

export function canRunOperationalBackgroundWork(): boolean {
  const uid = useAuthStore.getState().session?.user?.id;
  return getRequiresOwnerOnboardingForUser(uid) === false;
}
